import { useEffect, useRef, useState } from "react";
import { Col, Form, Row } from "react-bootstrap";
import { useTranslation } from 'react-i18next';

import { FieldArray, Formik } from "formik";

import _ from 'lodash';

import { HeaderRegister } from "../../../components/HeaderRegister";
import { ConfigImpositionModel } from "../../../models/configImposition.model"

import { ToastService } from "../../../services/toast.service";
import { DatasetDefault, DatasetModel } from '../../../models/dataset.model';
import { RequestInputOutputParamsModel, RequestInputOutputParamsModelDefault } from '../../../models/requestInputOutputParams.model';
import { init } from "i18next";
import ConfigService from "../../../services/config.service";

import storageService from "../../../services/storage.service";
import { EventService } from './../../../services/event.service';
import { ButtonClean, ButtonSearch } from "../../../components/buttons";
import { HeaderList } from "../../../components/HeaderList";
import HolidayService from "../../../services/holiday.service";


export const EventList = () => {


  const [isLoading, setLoading] = useState(false);
  const { t } = useTranslation();
  const user = storageService.getUser();
  const formRef = useRef();
  const [showNewModel, setShowNewModel] = useState(false);
  const [selectedList, setSelectedList] = useState([]);
  const [branchHolidayReferences, setBranchHolidayReferences] = useState([]); // Para armazenar os dados retornados
  const [filterType, setFilterType] = useState("national");
  const [holidayList, setHolidayList] = useState([]); // Para armazenar os feriados
  const [stateList, setStateList] = useState([]); // Para armazenar os estados
  const [selectedState, setSelectedState] = useState(null); // Para controlar o estado selecionado
  const [selectedHoliday, setSelectedHoliday] = useState(null); // Feriado Selecionado
  const [selectedItems, setSelectedItems] = useState([]);
  const [updatedItems, setUpdatedItems] = useState([]);


  const [dataset, setDataset] = useState<DatasetModel>({
    ...JSON.parse(JSON.stringify(DatasetDefault)),
    dataset: 'types',
    filters: {
      id_address_state: null, // Novo filtro
      id_holiday: 55 // Novo filtro
    },
    parameters: {},
    pagination: {
      page_number: 1,
      total_pages: 0,
      records_pages: 10000,
      total_records: 0
    },
  });



  const [datasetDashboardAnalytical, setDatasetDashboardAnalytical] = useState<DatasetModel>({
    ...JSON.parse(JSON.stringify(DatasetDefault)),
    dataset: 'types',
    filters: {
      id_address_state: null, // Novo filtro
      id_holiday: 55 // Novo filtro
    },
    pagination: {
      page_number: 1,
      total_pages: 0,
      records_pages: 21,
      total_records: 0
    },
  });


  const handleGetBranchesHolidayReferences = async () => {
    try {
      setLoading(true);

      // Construa requestParams como RequestInputOutputParamsModel
      const requestParams: RequestInputOutputParamsModel = {
        ...RequestInputOutputParamsModelDefault,
        datasets: [
          {
            ...datasetDashboardAnalytical,
            filters: {
              id_address_state: selectedState, // Valor do estado selecionado
              id_holiday: selectedHoliday, // Valor do feriado selecionado
            },
          },
        ],
      };


      // Chamada à API com os parâmetros
      const response: any = await EventService.GetBranchesHolidayReferences(requestParams);

      const data = response.result?.datasets[0]?.data || [];
      // Armazena os dados retornados
      setBranchHolidayReferences(data);

      // Inicializar os itens selecionados com base no `is_linked`
      const initiallySelected = data.filter((item) => item.is_linked).map((item) => item.id_branch);
      setSelectedItems(initiallySelected);

    } catch (error) {
      ToastService.error(t('ERROR_GENERIC'));
    } finally {
      setLoading(false);
    }
  };


  const initialize = async () => {
    setLoading(true);
    // Init
    setLoading(false);
  };


  useEffect(() => {
    initialize();
  }, []);


  const handleClean = () => {
    setFilterType("national"); // Redefine o tipo de filtro para "national"
    setSelectedState(null); // Remove a seleção de estado
    setSelectedHoliday(null); // Remove a seleção de feriado
    setSelectedItems([]); // Limpa os itens selecionados
    setUpdatedItems([]); // Limpa as alterações pendentes
    setBranchHolidayReferences([]); // Limpa os dados carregados

  };


  // Função para buscar feriados nacionais
  const fetchNationalHolidays = async () => {
    try {
      setLoading(true);

      // Chamada ao serviço
      const response: any = await HolidayService.getAllList();

      // Extraindo os feriados nacionais
      const nationalHolidays = response.result.datasets[1]?.data || [];

      // Armazenando os feriados nacionais no estado
      const filteredHolidays = nationalHolidays.filter((holiday) => holiday.addressStateId === null);
      setHolidayList(filteredHolidays);
    } catch (error) {
      ToastService.error(t("ERROR_GENERIC"));
    } finally {
      setLoading(false);
    }
  };



  // Função para buscar estados
  const fetchStates = async () => {
    try {
      setLoading(true);
      const response: any = await HolidayService.GetAllStateList();
      setStateList(response.result.datasets[0].data); // Armazena os estados
    } catch (error) {
      ToastService.error(t("ERROR_GENERIC"));
    } finally {
      setLoading(false);
    }
  };



  // Função para buscar feriados estaduais com base no estado selecionado
  const fetchStateHolidays = async (stateId) => {
    try {
      setLoading(true);

      // Chamada ao serviço
      const response: any = await HolidayService.getAllList();

      // Usando a lista 
      const holidays = response.result.datasets[1]?.data || [];

      // Certifique-se de que o tipo seja consistente
      const filteredHolidays = holidays.filter((holiday) => holiday.addressStateId == stateId); // Use `==` para comparação menos estrita

      // Atualizando o estado com os feriados filtrados
      setHolidayList(filteredHolidays);
    } catch (error) {
      ToastService.error(t("ERROR_GENERIC"));
    } finally {
      setLoading(false);
    }
  };



  // Efeito para atualizar quando o filtro é alterado
  useEffect(() => {
    if (filterType === "national") {
      fetchNationalHolidays(); // Buscar feriados nacionais
    } else if (filterType === "state") {
      fetchStates(); // Buscar lista de estados
    }
  }, [filterType]);

  // Função para lidar com a seleção de estado
  const handleStateChange = (id: string) => {
    setSelectedState(id);
    setSelectedHoliday(null); // Limpa o feriado selecionado
    if (id) {
      fetchStateHolidays(id); // Busca os feriados estaduais para o estado selecionado
    } else {
      setHolidayList([]); // Limpa a lista de feriados se nenhum estado for selecionado
    }
  };

  // Lidar com a seleção de feriado
  const handleHolidayChange = (e) => {
    setSelectedHoliday(e.target.value);
  };

  // Executar a busca toda vez que o selectedHoliday mudar
  useEffect(() => {
    if (selectedHoliday) {
      handleGetBranchesHolidayReferences();
    }
  }, [selectedHoliday]);


  const toggleSelectAll = (checked) => {
    const allIds = branchHolidayReferences.map((item) => item.id_branch);
  
    setSelectedItems(checked ? allIds : []);
  
    setUpdatedItems(() =>
      branchHolidayReferences.map((item) => ({
        id_branch: item.id_branch,
        id_holiday: item.id_holiday,
        is_linked: checked, // Define todos como selecionados ou desmarcados
      }))
    );
  
    console.log("🔹 toggleSelectAll acionado!");
    console.log("✅ Itens selecionados:", checked ? allIds : []);
    console.log("🔄 updatedItems atualizado:", updatedItems);
  };
  


  useEffect(() => {

  }, [updatedItems]);


  // Selecionar/Deselecionar um item individualmente
  const toggleSelectItem = (id) => {
    setSelectedItems((prevSelected) => {
      const isSelected = prevSelected.includes(id);
      const updatedList = isSelected
        ? prevSelected.filter((itemId) => itemId !== id)
        : [...prevSelected, id];
  
      setUpdatedItems((prevUpdates) => {
        const updatedItem = branchHolidayReferences.find((item) => item.id_branch === id);
        if (!updatedItem) return prevUpdates;
  
        const isCurrentlyLinked = updatedItem.is_linked;
        const isNowLinked = !isSelected;
  
        return prevUpdates.some((item) => item.id_branch === id)
          ? prevUpdates.map((item) =>
              item.id_branch === id ? { ...item, is_linked: isNowLinked } : item
            )
          : [...prevUpdates, { id_branch: id, id_holiday: updatedItem.id_holiday, is_linked: isNowLinked }];
      });
  
      console.log("🔹 toggleSelectItem acionado!");
      console.log("✅ Itens selecionados:", updatedList);
      console.log("🔄 updatedItems atualizado:", updatedItems);
  
      return updatedList;
    });
  };
  



  const handleSaveChanges = async () => {
    if (user.profile.profileName === "adm_reader" || user.profile.profileName === "sys_admin") {
      return; // Não executa a função
    }

    try {
      setLoading(true);

      const selectedItemsLog = branchHolidayReferences.filter((item) =>
        selectedItems.includes(item.id_branch)
      );
      const unselectedItemsLog = branchHolidayReferences.filter(
        (item) => !selectedItems.includes(item.id_branch)
      );

      console.log("Itens MARCADOS para salvar:", selectedItemsLog);
      console.log("Itens NÃO MARCADOS para salvar:", unselectedItemsLog);

      const requestParams: RequestInputOutputParamsModel = {
        ...RequestInputOutputParamsModelDefault,
        datasets: [
          {
            ...datasetDashboardAnalytical,
            filters: {
              filters: updatedItems, // Envia os itens atualizados
            },
          },
        ],
      };

      // Chamada à API para salvar
      const response: any = await EventService.UpdateBranchesHolidayReferences(requestParams);

      if (response.success) {
        ToastService.success(t("EVENT.CHANGES_SAVED"));
        // Atualizar os dados locais para refletir as alterações salvas
        //await handleGetBranchesHolidayReferences();
        // Atualizar o estado de branchHolidayReferences localmente
        
      const updatedReferences = branchHolidayReferences.map((item) => {
        const updatedItem = updatedItems.find((update) => update.id_branch === item.id_branch);
        if (updatedItem) {
          return { ...item, is_linked: updatedItem.is_linked };
        }
        return item;
      });

      setBranchHolidayReferences(updatedReferences);
      setUpdatedItems([]); // Limpar os itens atualizados
      }
    } catch (error) {
      ToastService.error(t("EVENT.ERROR_SAVING"));
    } finally {
      setLoading(false);
    }
  };

  // Função para lidar com a troca de tipo de feriado
  const handleFilterTypeChange = (type) => {
    setFilterType(type);
    setSelectedState(null); // Limpa seleção de estado
    setSelectedHoliday(null); // Limpa seleção de feriado
    setSelectedItems([]); // Limpa itens selecionados
    setUpdatedItems([]); // Limpa atualizações pendentes
    setBranchHolidayReferences([]); // Limpa os dados de filiais

    if (type === "national") {
      fetchNationalHolidays(); // Busca feriados nacionais
    } else if (type === "state") {
      fetchStates(); // Busca estados para feriados estaduais
    }
  };


  return (
    <>
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <HeaderList title={t(`EVENT.HOLIDAY_BRANCHES_TITLE`)} />
      </div>
      <Form.Label className="mb-1">{t("FILTERS")}</Form.Label>

      <Row className="align-items-center">
        {/* Dropdown Nacional/Estadual */}
        <Col sm={12} md={4} lg={2}>
          <Form.Group>
            <Form.Floating>
              <Form.Control
                as="select"
                className="form-control"
                value={filterType}
                onChange={(e) => handleFilterTypeChange(e.target.value)} // Atualiza o estado com a seleção
              >
                <option value="">{t("FILTER.SELECT")}</option>
                <option value="national">{t("FILTER.NATIONAL")}</option>
                <option value="state">{t("FILTER.STATE")}</option>
              </Form.Control>
              <label>{t("FILTER.TYPE_HOLIDAY")}</label>
            </Form.Floating>
          </Form.Group>
        </Col>

        {/* Dropdown de Estados (apenas se o filtro for estadual) */}
        {filterType === "state" && stateList.length > 0 && (
          <Col sm={12} md={4} lg={2}>
            <Form.Group>
              <Form.Floating>
                <Form.Control
                  as="select"
                  className="form-control"
                  value={selectedState || ""}
                  onChange={(e) => handleStateChange(e.target.value)}
                >
                  <option value="">{t("FILTER.SELECT_STATE")}</option>
                  {stateList?.map((state) => {
                    return <option key={state.id} value={state.id_address_state}>
                      {state.acronym}
                    </option>

                  })}
                </Form.Control>
                <label>{t("FILTER.STATE")}</label>
              </Form.Floating>
            </Form.Group>
          </Col>
        )}

        {/* Dropdown de Feriados */}
        {((filterType === "national" && holidayList.length > 0) || 
          (filterType === "state" && selectedState))  && (
          <Col sm={12} md={4} lg={2}>
            <Form.Group>
              <Form.Floating>
                <Form.Control
                  as="select"
                  className="form-control"
                  value={selectedHoliday || ""}
                  onChange={handleHolidayChange}
                >
                  <option value="">{t("FILTER.SELECT_HOLIDAY")}</option>
                  {holidayList.map((holiday) => (
                    <option key={holiday.id} value={holiday.id}>
                      {holiday.holidayName} {/* Exibe holidayName no seletor */}
                    </option>
                  ))}
                </Form.Control>
                <label>{t("FILTER.HOLIDAY")}</label>
              </Form.Floating>
            </Form.Group>
          </Col>
        )}

      </Row>


      <Row className='mt-3'>
        <Col xs="auto">
          <ButtonSearch
            onClick={(e) => handleGetBranchesHolidayReferences()}
            isLoading={isLoading}
            disabled={!selectedHoliday} // Desabilita se nenhum feriado estiver selecionado
          />
        </Col>

        <Col xs="auto">
          <ButtonClean onClick={async (e) => handleClean()} isLoading={isLoading} />
        </Col>


      </Row>

      <Row className="mt-3"></Row>



      {/* Exibição dos resultados */}
      {!!branchHolidayReferences && branchHolidayReferences.length > 0 && selectedHoliday && (

        <>
          <HeaderRegister
            title={`${t('FILTER.BRANCHES_HOLIDAYS')} ${holidayList.find(h => h.id.toString() === selectedHoliday)?.holidayName || t("")}`}
            //path={"/Models"}

            btnBack={false}
            submitForm={branchHolidayReferences.length > 0 ? handleSaveChanges : undefined}
            isDisabled={branchHolidayReferences.length === 0 || user.profile.profileName === "adm_reader" || user.profile.profileName === "sys_admin"}
          />
          <Row className="mt-4">
            <Col xs={12}>
              {/* Contêiner Flexível para Listagem */}
              <div style={{ display: "flex", flexWrap: "wrap", gap: "16px" }}>
                {/* Título de Seleção Global */}
                <div style={{ width: "100%" }}>
                <Form.Check
  type="checkbox"
  onChange={(e) => toggleSelectAll(e.target.checked)}
  label={t("SELECT_ALL")}
  checked={
    branchHolidayReferences.length > 0 && 
    selectedItems.length === branchHolidayReferences.length
  }
  disabled={user.profile.profileName === "adm_reader" || branchHolidayReferences.length === 0 || user.profile.profileName === "sys_admin"}
/>

                </div>

                {/* Listagem de Filiais */}
                <div
                  style={{
                    display: "grid", // Alteração para grid
                    gridTemplateColumns: "repeat(3, 1fr)", // Três colunas fixas
                    gap: "16px", // Espaçamento uniforme entre os itens
                    alignItems: "center", // Alinhamento vertical dos itens
                    width: "100%", // Garante que o grid ocupe 100% da largura do contêiner
                  }}
                >
                  {branchHolidayReferences.map((item) => (
                    <div
                      key={item.id_branch}
                      style={{
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <Form.Check
                        type="checkbox"
                        checked={selectedItems.includes(item.id_branch)}
                        onChange={() => toggleSelectItem(item.id_branch)}
                        style={{ marginRight: "10px" }}
                        disabled={user.profile.profileName === "adm_reader" || user.profile.profileName === "sys_admin"} // Desabilita o checkbox
                      />
                      <span>{item.branch_fullname}</span>
                    </div>
                  ))}
                </div>


              </div>
            </Col>
          </Row>
        </>

      )}

    </>

  );
};

export default EventList;